import { Component,  Input, OnInit } from '@angular/core';
import * as Quill from 'quill';
import { SectionMessageService } from '../../services/sectionMessage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SectionMessage } from 'app/modules/models/sectionMessage.type';

@Component({
  selector: 'app-session-message-viewer',
  templateUrl: './session-message-viewer.component.html',
  styleUrls: ['./session-message-viewer.component.scss']
})
export class SessionMessageViewerComponent implements OnInit {
  @Input() sectionId :string
  message : SectionMessage = {
    isActive :false
  };
  constructor(
    private _sessionMessageService : SectionMessageService,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.getBySectionIdAndCreateQuill();  
  }
  getBySectionIdAndCreateQuill(){
    this._sessionMessageService.getActiveBySectionId(this.sectionId).subscribe({
      next: (sectionMessage: SectionMessage) => {
        this.message = sectionMessage;    
        if(this.message?.isActive){
           this.createQuill();
        } 
      },
      error: err => {
        this._snackBar.open('Une erreur serveur est survenue !', null, { duration: 2000, panelClass: 'warn-snackbar' });
      }
    });
  }
  createQuill(){
    setTimeout(() => {
      const options = {
          readOnly: true,
          modules: {
            toolbar: null
          },
          theme: 'bubble'
        };
        const quill = new Quill('#editor', options);
    
      quill.setContents(JSON.parse(this.message.content));              
  }, 50);
  }
}
